import { IconFC } from '.';
type Props = {
  size?: number;
};

// 可以接受根据传入路径d来绘制不同的箭头,不需要改变箭头的方向
export const Arrow: IconFC<Props> = ({
  width = 12,
  height = 7,
  fill = '#262629',
  d = 'M10.6782 5.9145L5.99409 1.16666L1.30996 5.9145',
  ...restProps
}) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={width}
      height={height}
      viewBox={`0 0 ${width} ${height}`}
      fill='none'
      {...restProps}
    >
      <path d={d} stroke={fill} strokeWidth='1.5' strokeLinecap='round' strokeLinejoin='round' />
    </svg>
  );
};

export const ArrowTop: IconFC<Props> = ({ width = 12, height = 7, fill = '#262629', ...restProps }) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={width}
      height={height}
      viewBox={`0 0 ${width} ${height}`}
      fill='none'
      {...restProps}
    >
      <path
        d='M10.6782 5.9145L5.99409 1.16666L1.30996 5.9145'
        stroke={fill}
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  );
};

export const ArrowBottom: IconFC<Props> = (props) => {
  return (
    <ArrowTop {...props} style={{ ...props.style, transform: `rotate(180deg) ${props.style?.transform ?? ''}` }} />
  );
};

export const ArrowLeft: IconFC<Props> = (props) => {
  return (
    <ArrowTop {...props} style={{ ...props.style, transform: `rotate(-90deg) ${props.style?.transform ?? ''}` }} />
  );
};

export const ArrowRight: IconFC<Props> = (props) => {
  return <ArrowTop {...props} style={{ ...props.style, transform: `rotate(90deg) ${props.style?.transform ?? ''}` }} />;
};
